<script setup lang="ts">
</script>

<template>
<span class="xicon baseline">
    <svg width="32" height="32" viewBox="0 0 8.4666661 8.466667">
<g
    transform="translate(-68.579204,-80.103198)"
    id="layer1">
    <g
        style="stroke-width:0.9447552"
        transform="matrix(1.0584753,0,0,1.0584757,-4.2954619,-4.9893535)"
        id="g2004">
      <path
          d="m 75.315797,84.200264 c -0.237786,0 -0.475787,0.03768 -0.698984,0.113016 -0.296233,0.09999 -0.562482,0.276478 -0.710232,0.519552 0.08498,0.02246 0.169731,0.04537 0.252813,0.07338 0.420463,0.141768 0.814106,0.363622 1.10552,0.664169 0.01656,0.01708 0.02911,0.03702 0.04499,0.05463 h 0.0064 1.159619 c 0.205454,2.6e-4 0.372052,-0.166579 0.37172,-0.372256 0,-0.468617 -0.386499,-0.788804 -0.832889,-0.939478 -0.223197,-0.07534 -0.4612,-0.113016 -0.698986,-0.113016 z"
          id="path1946" />
      <path
          d="m 76.096523,83.165116 a 0.78015519,0.78099897 0 0 1 -0.780155,0.780999 0.78015519,0.78099897 0 0 1 -0.780155,-0.780999 0.78015519,0.78099897 0 0 1 0.780155,-0.780999 0.78015519,0.78099897 0 0 1 0.780155,0.780999 z"
          id="circle1948" />
      <path
          d="m 70.379521,84.200264 c -0.237786,0 -0.475789,0.03768 -0.698985,0.113016 -0.446393,0.150674 -0.831819,0.470861 -0.831819,0.939478 -3.32e-4,0.205258 0.165614,0.371923 0.37065,0.372256 h 1.16069 0.0054 c 0.01586,-0.01761 0.02845,-0.03755 0.04499,-0.05463 0.290909,-0.300565 0.682899,-0.522396 1.103379,-0.664169 0.08399,-0.02832 0.169559,-0.0518 0.255491,-0.07445 -0.148209,-0.24254 -0.414951,-0.41863 -0.710769,-0.51848 -0.223196,-0.07534 -0.461198,-0.113016 -0.698984,-0.113016 z"
          id="path1934" />
      <path
          d="m 71.160249,83.165116 a 0.78015519,0.78099897 0 0 1 -0.780155,0.780999 0.78015519,0.78099897 0 0 1 -0.780156,-0.780999 0.78015519,0.78099897 0 0 1 0.780156,-0.780999 0.78015519,0.78099897 0 0 1 0.780155,0.780999 z"
          id="circle1936" />
      <path
          d="m 74.990039,87.390656 a 0.68566263,0.68566263 0 0 0 0.68627,-0.686268 c 0,-0.864549 -0.7141,-1.454902 -1.538538,-1.73288 -0.824439,-0.277978 -1.756662,-0.277978 -2.581101,0 -0.824437,0.277978 -1.536513,0.868331 -1.536513,1.73288 a 0.68566263,0.68566263 0 0 0 0.684245,0.686268 h 2.143831 z"
          id="path1904" />
      <path
          d="m 74.289092,82.852822 a 1.4408611,1.4408611 0 0 1 -1.440861,1.440861 1.4408611,1.4408611 0 0 1 -1.440861,-1.440861 1.4408611,1.4408611 0 0 1 1.440861,-1.440861 1.4408611,1.4408611 0 0 1 1.440861,1.440861 z"
          id="path1918" />
    </g>
  </g>
    </svg>
</span>
</template>

<style scoped>
.xicon {
  display: inline-flex;
  align-self: center;
}

.xicon svg {
  height: 1em;
  width: 1em;
  fill: currentColor;
}

.xicon.baseline svg {
  top: .125em;
  position: relative;
}
</style>